<template>
  <div>
      <div class="dialog-container">
        <div class="selected-list">
          已选品牌：<span v-for="item,index in selectList" :key="index">{{item.brandName}} <i v-if="index !== selectList.length - 1">、</i> </span>
        </div>
        <div class="search-row">
          <div class="search-form">
            品牌
            <el-cascader v-model="brandCodeList" :options="options" :props="cascaderProp" filterable clearable placeholder="请选择品牌"></el-cascader>SKU编码
            <el-input v-model="brandParams.skuCode" placeholder="请输入SKU编码" clearable></el-input>SKU名称
            <el-input v-model="brandParams.skuName" placeholder="请输入SKU名称" clearable></el-input>
          </div>
          <div class="handle-box">
            <el-button class="btn btn-red" @click="search">搜索</el-button>
            <el-button class="btn btn-reset" @click="resetSearch">重置</el-button>
          </div>
        </div>
        <!-- 数据列表 -->
        <el-table
          :data="skuList"
          border
          :row-key="brandRowKey"
          @select="getSelectBrand"
          @select-all="selectAllBrand"
          class="dialog-table"
          ref="skuTable"
        >
          <el-table-column align="center" prop="parentBrandName" label="品牌" min-width="50%" />
          <el-table-column align="center" prop="subBrandName" label="子品牌" min-width="50%" />
          <el-table-column align="center" prop="skuCode" label="SKU编码" min-width="50%" />
          <el-table-column align="center" prop="skuName" label="SKU名称" min-width="50%" />
          <el-table-column
            align="center"
            type="selection"
            :reserve-selection="true"
            width="200px"
            min-width="50%"
          />
        </el-table>
        <el-row class="while-data-table-footer" v-if="skuList.length">
          <el-col>
            <el-pagination
              background
              :current-page="brandParams.currentPage"
              :page-size="brandParams.pageSize"
              :total="brandParams.total"
              layout="total, prev, pager, next"
              @current-change="handleCurrentChange"
            />
          </el-col>
        </el-row>
      </div>
  </div>
</template>

<script>
import tradeApi from '@/api/trade.js'
// import { mapGetters } from 'vuex'
export default {
  props: {
    selectedList: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data () {
    return {
      brandParams: {
        brandCode: '',
        subBrandCode: '',
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      brandCodeList: [],
      skuList: [],
      selectList: [], // 选中品牌列表
      selectedSkuList: [],
      tmpList: [],
      cascaderProp: { expandTrigger: 'hover', value: 'brandCode', label: 'brandName', children: 'subBrandList' },
      options: []
    }
  },
  watch: {
    selectedList () {
      this.selectList = JSON.parse(JSON.stringify(this.selectedList)) || []
      this.selectList = this.selectList.map(item => {
        item.skuName = item.brandName
        item.skuCode = item.brandCode
        return item
      })
      this.showBrandSelected()
    }
  },
  created () {
    this.init()
  },
  methods: {
    init () {
      this.queryBrandList()
      this.search()
      this.selectList = JSON.parse(JSON.stringify(this.selectedList)) || []
      this.selectList = this.selectList.map(item => {
        item.skuName = item.brandName
        item.skuCode = item.brandCode
        return item
      })
      this.showBrandSelected()
    },
    // 搜索
    search () {
      this.brandParams.page = 1
      this.getSkuList()
    },
    // 获取sku列表
    getSkuList () {
      this.brandParams.brandCode = this.brandCodeList[0]
      this.brandParams.subBrandCode = this.brandCodeList[1]
      this.brandParams.isAbiOwn = 1
      this.brandParams.skuSource = 'bees'
      tradeApi.getStrSku(this.brandParams).then(res => {
        if (res.data.resultCode === '0') {
          this.brandParams.total = res.data.resultData.pageInfo.totalCounts
          this.skuList = res.data.resultData.skuList || []
          this.showBrandSelected()
        }
      })
    },
    // 获取品牌下拉列表
    queryBrandList () {
      tradeApi.getStrSkuSelect(this.brandParams).then(res => {
        if (res.data.resultCode === '0') {
          this.options = res.data.resultData.brandList
        }
      })
    },
    // 重置搜索条件
    resetSearch () {
      this.brandParams = this.$options.data().brandParams
      this.brandCodeList = []
      this.getSkuList()
    },
    // 品牌列表分页
    handleCurrentChange (val) {
      this.brandParams.page = val
      this.getSkuList()
    },
    // sku弹窗每行标志位
    brandRowKey (row) {
      return row.skuCode
    },
    // 已勾选 表格对应展示
    showBrandSelected () {
      this.$nextTick(() => {
        this.skuList.map(brand => {
          const matchedBrand = this.selectList.find(selectedBrand => {
            return (selectedBrand.skuCode === brand.skuCode) || (selectedBrand.brandCode === brand.skuCode)
          })
          this.$refs.skuTable.toggleRowSelection(brand, Boolean(matchedBrand))
        })
      })
    },
    // 选择赠酒SKU
    getSelectBrand (selectList, row) {
      let flag = this.selectList.some((item) => {
        return item.brandCode === row.skuCode
      })
      if (flag) {
        this.selectList.forEach((item, index) => {
          if (item.brandCode === row.skuCode) {
            this.selectList.splice(index, 1)
          }
        })
      } else {
        let obj = {
          brandName: row.skuName,
          brandCode: row.skuCode
        }
        this.selectList.push(obj)
      }
      this.$emit('strSku', this.selectList)
    },
    // 赠酒sku全选
    selectAllBrand (selectList) {
      this.selectList = Object.assign([], selectList).map(item => {
        let obj = {
          brandName: item.skuName,
          brandCode: item.skuCode
        }
        return obj
      })
      this.$emit('strSku', this.selectList)
    }
  }
}
</script>

<style lang="scss" scoped>
.dialog-container {
    .selected-list {
    line-height: 40px;
    color: #000;
  }
  .search-row {
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;
  }
}
.el-input,
.el-select,
.el-cascader {
  width: 150px;
  margin: 0 20px 0 10px;
  line-height: 30px;
  &::v-deep .el-input__inner {
    height: 30px;
  }
}
.el-button {
  width: 80px;
  height: 30px;
  padding: 0 20px;
}
.dialog-table {
  ::v-deep .el-table__header-wrapper .el-checkbox__input::after {
    content: '全选';
    position: absolute;
    margin: 0 0 0 10px;
    font-weight: 700;
    color: rgb(144, 147, 153);
  }
}
.dialog-footer {
  text-align: center;
  margin-top: 20px;
}
</style>
